import React from "react";
import AppTemplate from "../components/Faq";

const Faq: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default Faq;
